<template>
  <v-app width="100dvw" height="100dvh" class="overflow-x-hidden">
    <v-navigation-drawer
      v-if="isLoggedIn && $route.name != 'Login' && terminalMode != 'true'"
      app
      flat
      :mini-variant.sync="mini"
      mobile-breakpoint="xs"
      v-click-outside="closeNavigation"
      class="rounded-0 d-none d-sm-none d-md-flex"
      mini-variant-width="80px"
      ref="navigationDrawer"
    >
      <Navigation v-if="$route.name != 'Setup' && terminalMode != 'true'" :mini="mini" @closeNavigation="mini = !mini" />
    </v-navigation-drawer>
    <v-main :style="mainStyle">
      <v-container fluid v-if="!isMobileDevice">
        <v-row class="px-7 pb-8" justify="space-between" no-gutters>
          <v-col cols="3" v-if="$route.name == 'Login'"></v-col>
          <v-col cols="2" class="d-flex justify-center">
            <v-img v-if="isMobileDevice" @click="emitLogoClicked" :src="source" max-height="85px" max-width="85px" contain></v-img>
            <v-img v-if="!isMobileDevice" :src="source" max-height="170px" max-width="170px" contain></v-img>
          </v-col>

          <v-col cols="3" class="d-flex justify-end">
            <v-row no-gutters justify="end" class="d-flex align-center">
              <v-tooltip bottom :color="setColor()">
                <template slot="activator" slot-scope="{ on }">
                  <v-avatar :color="setColor()" class="mr-4" size="10" v-on="on"> </v-avatar>
                </template>
                <span>{{ setConnectionText() }}</span>
              </v-tooltip>

              <v-switch v-model="$vuetify.theme.dark" @click="setLocalStorageTheme()">
                <v-icon v-if="$vuetify.theme.dark" class="mr-2" slot="label">mdi-white-balance-sunny</v-icon>
                <v-icon v-else class="mr-2" slot="label">mdi-moon-waning-crescent</v-icon>
              </v-switch>
              <LanguagePicker />
              <v-btn v-if="(isMobileDevice && $route.name != 'Login') || (terminalMode == 'true' && $route.name != 'Login')" icon @click="logout()">
                <v-icon>mdi-logout</v-icon>
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <!--Logo v-bind:mynewlogo="$store.getters['server/logo']" style="height: 80px" /-->
        <router-view :class="isMobileDevice ? '' : ''"></router-view>
      </v-container>
      <v-container fluid v-if="isMobileDevice">
        <v-row justify="space-between" no-gutters>
          <v-img v-if="isMobileDevice" @click="emitLogoClicked" :src="source" max-height="85px" max-width="85px" contain></v-img>

          <v-row no-gutters justify="end" class="d-flex align-center">
            <v-avatar :color="setColor()" class="mr-4" size="10"> </v-avatar>
            <v-switch v-model="$vuetify.theme.dark" @click="setLocalStorageTheme()">
              <v-icon v-if="$vuetify.theme.dark" class="mr-2" slot="label">mdi-white-balance-sunny</v-icon>
              <v-icon v-else class="mr-2" slot="label">mdi-moon-waning-crescent</v-icon>
            </v-switch>
            <LanguagePicker />
            <v-btn v-if="isMobileDevice || terminalMode == 'true'" icon @click="logout()">
              <v-icon class="d-flex d-md-none mr-2">mdi-logout</v-icon>
            </v-btn>
          </v-row>
        </v-row>
        <!--Logo v-bind:mynewlogo="$store.getters['server/logo']" style="height: 80px" /-->
        <router-view :class="isMobileDevice ? '' : ''"></router-view>
      </v-container>
    </v-main>

    <Notification @HideDrawer="hideDrawer"></Notification>
  </v-app>
</template>

<script>
import Notification from "./components/Global/Notification";
//import Logo from "./components/Global/Logo";
import Navigation from "./components/Navigation.vue";
import LanguagePicker from "./components/SimpleComponents/LanguagePicker";
import Helper from "./js/Helper";

import { DataStorage } from "./plugins/storageHelper";
import { mapGetters } from "vuex";

if (!String.prototype.format) {
  String.prototype.format = function () {
    var args = arguments;
    return this.replace(/{(\d+)}/g, function (match, number) {
      return typeof args[number] != "undefined" ? args[number] : match;
    });
  };
}

export default {
  name: "App",
  components: { Notification, Navigation, LanguagePicker },
  data: (vm) => ({
    drawerVisible: true,
    items: [{ icon: "mdi-home", text: "Main Page", path: "Home" }],
    mini: true,
    mainStyle: "",

    isMobileDevice: Helper.isMobile(),
    connectionToSAP: null
  }),
  beforeCreate() {
    let darkMode = DataStorage.get("darkMode");
    if (darkMode !== null) {
      this.$vuetify.theme.dark = JSON.parse(darkMode);
    }
  },
  created: async function () {
    await this.checkConnection();
    if (this.isLoggedIn) {
      await this.getSettings();
      if (this.$route.name != "MainMenu") {
        await this.getStatus(false);
      }
    }

    if (this.$store.getters["settings/firstRun"] == true && this.$router.currentRoute.name != "Start") {
      this.$router.push("Start");
    }
    this.$store
      .dispatch("server/getLogo")
      .then(() => {})
      .catch((err) => {});
  },
  methods: {
    emitLogoClicked() {
      this.$eventHub.$emit("logo-click");
    },
    hideDrawer(val) {
      this.drawerVisible = !val;
    },
    setLocalStorageTheme() {
      DataStorage.save("darkMode", this.$vuetify.theme.dark);
    },
    closeNavigation() {
      if (!this.mini) this.mini = true;
    },
    async getSettings() {
      this.loaderOverlay = true;
      await this.$store
        .dispatch("server/getSettings", this.$moment())
        .then(() => {})
        .catch((err) => {
          if (err.response.status != 200) {
            //this.$eventHub.$emit("showError", err.response.data.error, "bottom", "right");
          }
        });
      this.loaderOverlay = false;
    },
    async getStatus(executeImmediately) {
      this.loaderOverlay = true;
      await this.$store
        .dispatch("user/getStatus", {
          timeStamp: this.$moment(),
          executeImmediately: executeImmediately
        })
        .then(async () => {
          this.loaderOverlay = false;
        })
        .catch((err) => {
          this.loaderOverlay = false;
          if (err.response.status != 200) {
            this.$eventHub.$emit("showError", err.response.data.error, "bottom", "right");
          }
        });
    },

    async showMessage(message) {
      return await this.$dialog
        .confirm(message, {
          okText: this.$t("ok"),
          cancelText: this.$t("cancel")
        })
        .then(() => {
          return true;
        })
        .catch(function () {
          return false;
        });
    },
    async logout() {
      let result = await this.showMessage(this.$t("logoutWarning"));
      if (!result) return;

      this.$store.dispatch("user/logout").then(() => {
        this.$router.push("/Login");
      });
    },
    async checkConnection() {
      return await this.$store
        .dispatch("server/checkConnection")
        .then((resp) => {
          clearTimeout(this.connectionToSAP);
          return true;
        })
        .catch((err) => {
          this.connectionToSAP = setTimeout(this.checkConnection, 5000);
          //this.$eventHub.$emit("showError", "Failed to Connect with SAP", "bottom", "right");

          return false;
        });
    },
    setColor() {
      switch (this.$store.getters["server/sapConnection"]) {
        case "connected":
          return "green";
        case "disconnected":
          return "red";
        case "connecting":
          return "#FDD835";
        default:
          return "red";
      }
    },
    setConnectionText() {
      switch (this.$store.getters["server/sapConnection"]) {
        case "connected":
          return this.$t("connectWasSuccessful");
        case "disconnected":
          return this.$t("connectionHasFailed");
        case "connecting":
          return this.$t("connectingToSAP");
        default:
          return this.$t("connectionHasFailed");
      }
    }
  },
  computed: {
    ...mapGetters({
      User: "user/user",
      terminalMode: "settings/terminalMode"
    }),
    isLoggedIn: function () {
      return this.$store.getters["user/isLoggedIn"];
    },
    isMobile: function () {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return true;
        default:
          return false;
      }
    },
    currentRouteName() {
      return this.$route.name;
    },
    source() {
      return this.$store.getters["server/logo"] || "/logo/COBI.time.png";
    }
  },
  watch: {
    $route(to, from) {
      if (to.name == "Login" || to.name == "Setup") {
        this.mainStyle = "padding-left: 0px";
        this.mini = true;
      }
      if (to.name != "Login" && !this.mini) this.mainStyle = "padding-left: 256px";
      if (this.$route.name != "Login" && this.mini) this.mainStyle = "padding-left: 80px";
      if (to.name != "Login" && this.terminalMode === "true") this.mainStyle = "padding-left: 0px";
      if (this.isMobile) this.mainStyle = "padding-left: 0px";
    },
    mini(val) {
      if (val && this.$route.name != "Login" && this.terminalMode === "false") {
        this.mainStyle = "padding-left: 80px";
      } else if (this.$route.name == "Login") this.mainStyle = "padding-left: 0px";
      else this.mainStyle = "padding-left: 256px";
    },
    $vuetify: {
      deep: true,
      handler() {
        // document.getElementById("app").classList.add(this.$vuetify.theme.dark ? "scrollbar-dark" : "scrollbar-light");
        // document.getElementById("app").classList.remove(this.$vuetify.theme.dark ? "scrollbar-light" : "scrollbar-dark");
      }
    }
  }
};
</script>

<style>
#app1 {
  font-family: sans-serif, "Avenir", Helvetica, Arial;
  /* this was it */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.red--text.text--darken-4 {
  color: #b31616 !important;
  caret-color: #b31616 !important;
}

body {
  padding: 0 !important;
  margin: 0 !important;
}

.centered-input input {
  text-align: center;
  font-size: 15pt;
  /* font-size: 20px; */
}

.overflow-hidden {
  overflow: hidden;
}

.horiz-scroll {
  overflow-y: hidden;
  overflow-x: auto;
}

.my-event {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 2px;
  background-color: #1867c0;
  color: #ffffff;
  border: 1px solid #1867c0;
  width: 100%;
  font-size: 12px;
  padding: 3px;
  cursor: pointer;
  margin-bottom: 1px;
}

.my-errorEvent {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 2px;
  background-color: red;
  color: #ffffff;
  border: 1px solid darkred;
  width: 100%;
  font-size: 12px;
  padding: 3px;
  cursor: pointer;
  margin-bottom: 1px;
}

.v-alert.v-alert {
  border-color: transparent !important;
  border-radius: 7px;
}

.buttonHoverOpacity:hover {
  opacity: 0.5;
}

.myHorizontalScrollContainer {
  white-space: nowrap;
  display: -webkit-flex;
  flex-direction: row;
  -webkit-flex-direction: row;
  overflow-y: scroll;
}

.v-dialog.dialogLegende.v-dialog {
  position: absolute;
  right: 0;
  margin-right: 0;
  margin-top: 0;
  top: 0;
  height: 100%;
  max-height: 100%;
}

/* Dialog Handler */

.dg-btn--cancel {
  background-color: #b71c1c !important;
  text-transform: uppercase;
}

.dg-btn--ok {
  color: #ffffff !important;
  background-color: #b31616 !important;
  border-color: #b31616 !important;
  text-transform: uppercase;
}

.dg-btn--ok:hover {
  opacity: 0.5;
}

.dg-btn--cancel:hover {
  opacity: 0.5;
}

.dg-content {
  font-size: 16px;
  line-height: 2.3em;
  text-align: center;
  font-family: Roboto, sans-serif;
}

.dg-content-footer {
  font-family: Roboto, sans-serif;
}

.unselectable {
  -moz-user-select: -moz-none;
  -khtml-user-select: none;
  -webkit-user-select: none;

  /*
     Introduced in IE 10.
     See http://ie.microsoft.com/testdrive/HTML5/msUserSelect/
   */
  -ms-user-select: none;
  user-select: none;
}

/* General  */
::-webkit-scrollbar {
  width: 0.75rem;
  height: 0.75rem;
  overflow: hidden;
}
::-webkit-scrollbar-thumb {
  border-radius: 500px;
}

/* Dark Mode  */
.theme--dark ::-webkit-scrollbar {
  background-color: #2e2e2e;
}
.theme--dark ::-webkit-scrollbar-track {
  background: #2e2e2e;
}
.theme--dark ::-webkit-scrollbar-thumb {
  background: #3a3a3a;
}
.theme--dark ::-webkit-scrollbar-thumb:hover {
  background: #484848;
}
.theme--dark ::-webkit-scrollbar-corner {
  background: #2e2e2e;
}

/* Light Mode */
.theme--light ::-webkit-scrollbar {
  background-color: #ffffff;
}
.theme--light ::-webkit-scrollbar-track {
  background: #dcdcdc;
}
.theme--light ::-webkit-scrollbar-thumb {
  background: #bebebe;
}
.theme--light ::-webkit-scrollbar-thumb:hover {
  background: #b1b1b1;
}
.theme--light ::-webkit-scrollbar-corner {
  background: #dcdcdc;
}
</style>
